"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLock = void 0;

var React = __importStar(require("react"));

exports.IconLock = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "33",
    height: "40",
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M28.821 16.0626H27.7178V8.56178C27.716 3.81278 23.9149 0 19.3158 0H13.184C8.58467 0 4.78373 3.81268 4.78373 8.56178V16.0626H3.68042C1.65663 16.0626 0.00167674 17.7494 0.00167674 19.8121L0 36.2505C0 38.3133 1.65495 40 3.67875 40H28.8195C30.8432 40 32.4982 38.3133 32.4982 36.2505L32.5 19.8121C32.5 17.7494 30.8435 16.0626 28.8212 16.0626H28.821ZM7.23483 8.56178C7.23483 5.2498 9.87232 2.50028 13.182 2.50028H19.3138C22.5632 2.50028 25.261 5.18848 25.261 8.56178V16.0626H7.2344L7.23483 8.56178ZM30.047 36.2505C30.047 36.9375 29.4952 37.4997 28.8212 37.4997H3.68047C3.00643 37.4997 2.45476 36.9375 2.45476 36.2505L2.45308 19.812C2.45308 19.125 3.00475 18.5627 3.6788 18.5627H28.8195C29.4937 18.5627 30.0452 19.125 30.0452 19.812L30.047 36.2505Z",
    fill: color
  }), React.createElement("path", {
    d: "M16.2485 21.376C13.673 21.376 11.5268 23.5003 11.5268 26.1884C11.5268 28.3759 12.999 30.2507 15.0228 30.8128V32.7507C15.0228 33.4377 15.5744 34 16.2485 34C16.9225 34 17.4742 33.4377 17.4742 32.7507V30.8128C19.498 30.2505 20.9702 28.3758 20.9702 26.1884C20.9702 23.5003 18.8239 21.376 16.2485 21.376ZM16.2485 28.4376C15.0228 28.4376 13.9798 27.4378 13.9798 26.1253C13.9798 24.8129 14.9607 23.8131 16.2485 23.8131C17.5362 23.8131 18.5171 24.8129 18.5171 26.1253C18.5188 27.4378 17.4759 28.4376 16.2485 28.4376Z",
    fill: color
  }));
});